import { AxiosResponse } from 'axios';

import { enqueueSnackbar } from '@common/components/SnackBar';

import completionMessages from './completionMessages';

export function joinErrors(data: any) {
	// @TODO: TS
	const errorsEntries = data?.errors
		? Object.keys(data?.errors).map((key) => [
				key,
				Array.isArray(data?.errors[key]) ? data?.errors[key].join(', ') : data?.errors[key],
			])
		: [];
	const errors = Object.fromEntries(errorsEntries);
	return { ...data, errors };
}

function isApiVersionGreater(currentVersion: string, headerVersion: string): boolean {
	const currentVersionParts = currentVersion.split('.').map(Number);
	const headerVersionParts = headerVersion.split('.').map(Number);

	for (let i = 0; i < Math.max(currentVersionParts.length, headerVersionParts.length); i++) {
		const currentPart = currentVersionParts[i] || 0;
		const headerPart = headerVersionParts[i] || 0;

		if (headerPart > currentPart) {
			return true; // Api version is greater
		}

		if (headerPart < currentPart) {
			return false;
		}
	}
	return false; // Versions are equal
}

export function processResponse(response: AxiosResponse | any) {
	const apiVersion = response.headers?.['x-app-version'];
	let curentApiVersion = localStorage.getItem('apiVersion');
	const pwaEnabledHeader = response.headers?.['x-pwa-enabled'];

	if (!curentApiVersion) {
		localStorage.setItem('apiVersion', apiVersion);
		curentApiVersion = apiVersion;
	}

	if (apiVersion && isApiVersionGreater(curentApiVersion, apiVersion)) {
		localStorage.setItem('wrongApiVersion', 'true');
	}

	if (typeof pwaEnabledHeader !== 'undefined') {
		const normalized = String(pwaEnabledHeader).toLowerCase();
		const isPwaEnabled = normalized === 'true' || normalized === '1';
		localStorage.setItem('pwaEnabled', String(isPwaEnabled));
	}

	const data = response.data || response.message;
	if (data?.code === 422 || data?.code === 409) {
		return Promise.reject(joinErrors(data));
	}
	if (data?.code === 401) {
		const joinedErrors = joinErrors(data);
		Object.values(joinedErrors.errors).forEach((error: any) => {
			enqueueSnackbar(error, {
				variant: 'error',
			});
		});
		return Promise.reject(joinedErrors);
	}
	completionMessages.enqueue(data?.completion_message);
	return data;
}
